import { render } from "./DetailModal.vue?vue&type=template&id=0639bc12&scoped=true&ts=true"
import script from "./DetailModal.vue?vue&type=script&lang=ts"
export * from "./DetailModal.vue?vue&type=script&lang=ts"

import "./DetailModal.vue?vue&type=style&index=0&id=0639bc12&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0639bc12"]])

export default __exports__